
import { createApi } from "@reduxjs/toolkit/query/react";
import { defaultBaseQuery } from "../../../utils/API/fetchBaseQuery";
import { transformErrorResponse, transformSuccessResponse } from "../../../utils/API/responseMiddleware";
import { encryptAES } from "../../../services/CryptoService";
import { encryptQueryString, transformRequest } from "../../../utils/API/requestMiddleware";


const BookingCancelationListServiceApi = createApi({
    reducerPath: 'BookingCancelationListServiceApi',
    baseQuery: defaultBaseQuery,
    endpoints: (builder) => ({
        GetBookingCancellationList: builder.mutation({
            query: (details) => ({
                url: `/EventManagement/GetBookingCancellationList`,
                method: 'POST',
                body: transformRequest(details),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        GetBookingCancellationDetailsById: builder.query({
            query: (cancellationId) => ({
                url: `/EventManagement/GetBookingCancellationDetailsById?id=${encryptAES(cancellationId)}`,
                method: 'GET',
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        RejectBookingCancelationById: builder.query({
            query: ({cancellationId, createdAppId , createdBy}) => ({
                //url: `/EventManagement/RejectBookingCancelationById?id=${encryptAES(cancellationId)}&id1=${encryptAES(createdAppId)}&id1=${encryptAES(createdBy)}`,
                url: `/EventManagement/RejectBookingCancelationById?id=${encryptAES(cancellationId)}&id1=${encryptAES(createdAppId)}&id2=${encryptAES(createdBy)}`,
                method: 'POST',
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
    }),
})

export const {
    useGetBookingCancellationListMutation,
    useLazyGetBookingCancellationDetailsByIdQuery,
    useLazyRejectBookingCancelationByIdQuery
} = BookingCancelationListServiceApi;

export default BookingCancelationListServiceApi;